import angular from "angular";

angular
    .module('app')
    .component('individualStudentAttach', {
        template: require('./individual-student-attach.html'),
        controller: ['$http', 'Notifier', 'ErrorResponseParser', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, Notifier, ErrorResponseParser) {


    let $ctrl = this;

    $ctrl.user = null;

    $ctrl.$onInit = function () {
        $ctrl.course = $ctrl.resolve.course;
    };

    $ctrl.attachStudent = function () {
        $ctrl.close({$value: $ctrl.user});
    };

    $ctrl.getUsers = function (fragment) {
        return $http
            .get('/admin/users/get-by-fragment', {params: {fragment}})
            .then(
                function (response) {
                    return response.data.users;
                },
                function (error) {

                    Notifier.error(error.data.message, 2);

                    $ctrl.loading = false;
                }
            )
    };

}
